import { createSlice } from "@reduxjs/toolkit";
import {
  createResourceSchedule,
  fetchResourceSchedules,
  updateResourceSchedule,
  deleteResourceSchedule,
} from "../thunks/resourceScheduleThunk";

const initialState = {
  schedules: [],
  status: "idle",
  error: null,
};

const resourceScheduleSlice = createSlice({
  name: "resourceSchedules",
  initialState,
  reducers: {
    clearSchedules: (state) => {
      state.schedules = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Create schedule
      .addCase(createResourceSchedule.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createResourceSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.schedules.push(action.payload);
        state.error = null;
      })
      .addCase(createResourceSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // Fetch schedules
      .addCase(fetchResourceSchedules.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchResourceSchedules.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.schedules = action.payload;
        state.error = null;
      })
      .addCase(fetchResourceSchedules.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // Update schedule
      .addCase(updateResourceSchedule.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateResourceSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        const index = state.schedules.findIndex(
          (sch) => sch._id === action.payload._id
        );
        if (index !== -1) {
          state.schedules[index] = action.payload;
        }
        state.error = null;
      })
      .addCase(updateResourceSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // Delete schedule
      .addCase(deleteResourceSchedule.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteResourceSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.schedules = state.schedules.filter(
          (sch) => sch._id !== action.payload.id
        );
        state.error = null;
      })
      .addCase(deleteResourceSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { clearSchedules } = resourceScheduleSlice.actions;
export default resourceScheduleSlice.reducer;
